import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { Customer } from '../../model/Customer'
import Divider from '@mui/material/Divider';
import { CustomerMeal } from '../../model/CustomerMeal';
import { MealDateComponent } from './MealDateComponent';
import './style.css'
import {Chip, IconButton} from '@mui/material';
import { Dayjs } from 'dayjs';
import { isMobile } from 'react-device-detect';
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import HistoryIcon from '@mui/icons-material/History';
import {useAuth0} from "@auth0/auth0-react";
import {EventPopover} from "../customer/EventPopover";
import Tooltip from "@mui/material/Tooltip";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export const MealSelectionForSingleCustomerComponent : React.FC<{index : number,
    customer : Customer, 
    page : number,
    pickedDate : Dayjs,
    setBillingTotal : Dispatch<SetStateAction<number>>,
    setBillingTotalAmount : Dispatch<SetStateAction<number>>,
    filteredCustomersList : Customer[],
    customerIdsList : number[],
    setCustomerIdsList : Dispatch<SetStateAction<number[]>>
}> = (props) => {

    const {
        user,
    } = useAuth0();

    const {index, customer, page, pickedDate,
        setBillingTotal, setBillingTotalAmount,
        filteredCustomersList, customerIdsList, setCustomerIdsList} = props
    const [total, setTotal] = useState<number>(0)
    const [totalAmount, setTotalAmount] = useState<number>(0)
    const [totalChanged, setTotalChanges] = useState<boolean>(true)
    const [showEvents, setShowEvents] = useState(false);
    
    useEffect(() => {
        setTotal(customer.customerMeals !== undefined ? customer.customerMeals.flatMap(cm => cm.recentMealDate).reduce((a,v) => a = a + v!.total, 0): 0)
        setTotalAmount(customer.customerMeals !== undefined ? customer.customerMeals.flatMap(cm => cm.recentMealDate).reduce((a,v) => a = a + v!.totalAmount, 0): 0)
    // eslint-disable-next-line
    },[totalChanged, page, filteredCustomersList])

    return (
        <>
        {isMobile ?
            <React.Fragment key={index}>
            <tr className='rowBackground' key={index}>
                <td className={'rowBackground customTextHeaderColor align-middle text-center'}>
                    <Chip className={'custom-chip mx-2'}
                            variant="outlined"
                            color="secondary"
                            label ={`Kwota: ${totalAmount} zł (sztuk: ${total})`} />
                    <IconButton>
                        <HistoryIcon/>
                    </IconButton>
                    {!user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT) &&
                    <IconButton disabled={customer.email === "Brak"} onClick={customerIdsList.includes(customer.customerid!) ?
                        () => setCustomerIdsList(customerIdsList.filter(id => id !== customer.customerid!))
                        :
                        () => setCustomerIdsList(prevState => [...prevState, customer.customerid!])
                    }>
                        {customerIdsList.includes(customer.customerid!) ? <MarkEmailReadIcon /> : <MailOutlineIcon />}
                    </IconButton>}
                    <br></br>
                        <b>{`${customer.firstName} ${customer.lastName} `}</b>
                    {customer.active ?
                        ""
                        :
                        <Tooltip title="Ten rodzic został wcześniej usunięty. Na tej stronie będzie widoczny tylko do końca bieżącego miesiąca"
                                 arrow placement="right">
                            <ErrorOutlineIcon fontSize="small" sx={{ color: 'orange' }}/>
                        </Tooltip>
                    }
                    <span style={{fontSize:'0.75rem'}}>{` (${customer.childName})`}</span>
                </td>
            </tr>
            {customer.customerMeals === undefined || customer.customerMeals?.length < 1 ?
                <tr>
                    <td colSpan={4} className='customTextColor'>Brak powiązanych posiłków</td>
                </tr>
            :
                <>
                    {customer.customerMeals?.sort((a, b) => a.meal.position >= b.meal.position ? 1 : -1)
                    .map((customerMeal : CustomerMeal, index : number) => (
                        <React.Fragment key={index} >
                            <MealDateComponent
                                customer={customer}
                                customerMeal={customerMeal}
                                pickedDate = {pickedDate}
                                setTotalChanges={setTotalChanges}
                                setBillingTotal={setBillingTotal}
                                setBillingTotalAmount={setBillingTotalAmount}/>
                        </React.Fragment>
                    ))}
                </>
            }
            <tr><td colSpan={15}><Divider sx={{ borderBottomWidth: 0, padding:'5px' }}/></td></tr>
            </React.Fragment>
        :
            <React.Fragment key={index}>
                <tr className='rowBackground' key={index}>
                    <td width={'30px'} className='rowBackground customTextHeaderColor align-middle text-center'>{index+1+(page-1)*10}</td>
                    <td className='rowBackground customTextHeaderColor align-middle' colSpan={3}>
                        <b>{`| ${customer.firstName} ${customer.lastName} `}</b>
                        {customer.active ?
                        ""
                        :
                        <Tooltip title="Ten rodzic został wcześniej usunięty. Na tej stronie będzie widoczny tylko do końca bieżącego miesiąca"
                                 arrow placement="right">
                            <ErrorOutlineIcon fontSize="small" sx={{ color: 'orange' }}/>
                        </Tooltip>
                        }
                        <span style={{fontSize:'0.75rem'}}>{` (${customer.childName})`}</span></td>
                    <td className={'rowBackground customTextHeaderColor align-middle text-right'} colSpan={3}>
                        <Chip className={'custom-chip mx-2'}
                                variant="outlined"
                                color="secondary"
                                label ={`Łącznie: ${total} szt. posiłków (kwota: ${totalAmount} zł)`} />
                        <IconButton onClick={() => setShowEvents(true)}>
                            <HistoryIcon/>
                        </IconButton>
                        {!user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT) &&
                        <IconButton disabled={customer.email === "Brak"} onClick={customerIdsList.includes(customer.customerid!) ?
                            () => setCustomerIdsList(customerIdsList.filter(id => id !== customer.customerid!))
                            :
                            () => setCustomerIdsList(prevState => [...prevState, customer.customerid!])
                        }>
                            {customerIdsList.includes(customer.customerid!) ? <MarkEmailReadIcon /> : <MailOutlineIcon />}
                        </IconButton>}
                    </td>
                </tr>
                {customer.customerMeals === undefined || customer.customerMeals?.length < 1 ?
                <tr>
                    <td colSpan={7} className='customTextColor'>Brak powiązanych posiłków</td>
                </tr>
                :
                <>
                    {customer.customerMeals?.sort((a, b) => a.meal.position >= b.meal.position ? 1 : -1)
                    .map((customerMeal : CustomerMeal, index : number) => (
                        <React.Fragment key={index} >
                            <MealDateComponent
                                customer={customer}
                                customerMeal={customerMeal}
                                pickedDate = {pickedDate}
                                setTotalChanges={setTotalChanges}
                                setBillingTotal={setBillingTotal}
                                setBillingTotalAmount={setBillingTotalAmount}/>
                        </React.Fragment>
                    ))}
                </>
                }
                <tr><td colSpan={15}><Divider sx={{ borderBottomWidth: 0, padding:'5px' }}/></td></tr>
            </React.Fragment>
        }
            <EventPopover customerId={customer.customerid!} showEvents={showEvents} setShowEvents={setShowEvents}/>
        </>
        
    )
}